import React from "react";
import AerospaceIcon from "./AerospaceIcon.svg?react";
import AgricultureIcon from "./AgricultureIcon.svg?react";
import AIIcon from "./AIIcon.svg?react";
import AutomotiveIcon from "./AutomotiveIcon.svg?react";
import BiotechnologyIcon from "./BiotechnologyIcon.svg?react";
import ChemicalIcon from "./ChemicalIcon.svg?react";
import ConstructionIcon from "./ConstructionIcon.svg?react";
import ConsultingIcon from "./ConsultingIcon.svg?react";
import CreativeIcon from "./CreativeIcon.svg?react";
import EducationIcon from "./EducationIcon.svg?react";
import ElectronicsIcon from "./ElectronicsIcon.svg?react";
import ExecutiveIcon from "./ExecutiveIcon.svg?react";
import FinancialServicesIcon from "./FinancialServicesIcon.svg?react";
import FishingIcon from "./FishingIcon.svg?react";
import FitnessIcon from "./FitnessIcon.svg?react";
import FoodBeverageIcon from "./FoodBeverageIcon.svg?react";
import ForestryIcon from "./ForestryIcon.svg?react";
import FurnitureIcon from "./FurnitureIcon.svg?react";
import GovernmentIcon from "./GovernmentIcon.svg?react";
import HealthcareIcon from "./HealthcareIcon.svg?react";
import HospitalityIcon from "./HospitalityIcon.svg?react";
import ITIcon from "./ITIcon.svg?react";
import LegalIcon from "./LegalIcon.svg?react";
import MediaIcon from "./MediaIcon.svg?react";
import MiningIcon from "./MiningIcon.svg?react";
import NonProfitIcon from "./NonProfitIcon.svg?react";
import OilGasIcon from "./OilGasIcon.svg?react";
import OthersIcon from "./OthersIcon.svg?react";
import PaperIcon from "./PaperIcon.svg?react";
import PharmaceuticalsIcon from "./PharmaceuticalsIcon.svg?react";
import PlasticIcon from "./PlasticIcon.svg?react";
import PublicAdminIcon from "./PublicAdminIcon.svg?react";
import RealEstateIcon from "./RealEstateIcon.svg?react";
import RenewableEnergyIcon from "./RenewableEnergyIcon.svg?react";
import ResearchIcon from "./ResearchIcon.svg?react";
import RetailIcon from "./RetailIcon.svg?react";
import ScientificIcon from "./ScientificIcon.svg?react";
import SpaceIcon from "./SpaceIcon.svg?react";
import SteelIcon from "./SteelIcon.svg?react";
import TelecommunicationsIcon from "./TelecommunicationsIcon.svg?react";
import TextileIcon from "./TextileIcon.svg?react";
import TransportationIcon from "./TransportationIcon.svg?react";

// Map industry IDs to their respective icons
const industryIcons: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  "17": HospitalityIcon,
  "18": FinancialServicesIcon,
  "19": ConstructionIcon,
  "59": AgricultureIcon,
  "60": ForestryIcon,
  "61": FishingIcon,
  "62": MiningIcon,
  "63": OilGasIcon,
  "64": AutomotiveIcon,
  "65": AerospaceIcon,
  "66": ElectronicsIcon,
  "67": ChemicalIcon,
  "68": PharmaceuticalsIcon,
  "69": FoodBeverageIcon,
  "70": TextileIcon,
  "71": SteelIcon,
  "72": FurnitureIcon,
  "73": PlasticIcon,
  "74": PaperIcon,
  "75": RenewableEnergyIcon,
  "76": RetailIcon,
  "77": HealthcareIcon,
  "78": EducationIcon,
  "79": RealEstateIcon,
  "80": TransportationIcon,
  "81": TelecommunicationsIcon,
  "82": ITIcon,
  "83": MediaIcon,
  "84": LegalIcon,
  "85": ConsultingIcon,
  "86": FitnessIcon,
  "87": PublicAdminIcon,
  "88": ResearchIcon,
  "89": ScientificIcon,
  "91": AIIcon,
  "92": BiotechnologyIcon,
  "93": SpaceIcon,
  "94": GovernmentIcon,
  "95": NonProfitIcon,
  "96": CreativeIcon,
  "97": ExecutiveIcon,
  "98": OthersIcon,
};

export default industryIcons;
